module.exports = __webpack_public_path__ + "media/images/webpage/shared/smf-icot-logo-header-463bce1247e3434be8112da8484c165e.png";